import { Store } from "redoodle";
import { IAppState } from "../store/state";
import { DataService } from "./dataService";
import { FirebaseAnalyticsService } from "./firebaseAnalyticsService";
import { FirebaseAuthService } from "./firebaseAuthService";
import { FirebaseAuthUiService } from "./firebaseAuthUiService";
import { FirebaseService } from "./firebaseService";
import { FirebaseStorageService } from "./firebaseStorageService";
import { FirestoreService } from "./firestoreService";
import { FunctionsService } from "./functionsService";

export type IGlobalServices = ReturnType<typeof getServices>;

function getServices(store: Store<IAppState> | undefined) {
    const firebaseService = new FirebaseService();
    const firebaseApp = firebaseService.getApp();
    const firebaseAnalyticsService = new FirebaseAnalyticsService(firebaseApp);
    const firebaseAuthService = new FirebaseAuthService(firebaseApp, firebaseAnalyticsService, store);
    const firebaseAuthUiService = new FirebaseAuthUiService(firebaseApp, firebaseAnalyticsService, store);
    const firestoreService = new FirestoreService(firebaseApp);
    const firebaseStorageService = new FirebaseStorageService(firebaseApp);
    const functionsService = new FunctionsService(firebaseApp);
    const dataService = new DataService(
        firestoreService,
        firebaseAuthService,
        store,
    );

    return {
        firebaseService,
        firebaseAnalyticsService,
        firebaseAuthService,
        firebaseAuthUiService,
        firestoreService,
        dataService,
        functionsService,
        firebaseStorageService,
    };
}

let GLOBAL_SERVICES: IGlobalServices | undefined;

export function getGlobalServices() {
    return GLOBAL_SERVICES;
}

export function initializeAndGetClientSideServices(store: Store<IAppState>) {
    GLOBAL_SERVICES = getServices(store);
    return GLOBAL_SERVICES;
}
